import {
  TranslationConcretingRequestMessages,
  ConcretingRequestMessages
} from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationConcretingRequestMessages = {
  [ConcretingRequestMessages.stepContractText]: "Contrato",
  [ConcretingRequestMessages.stepConcretingText]: "Programação",
  [ConcretingRequestMessages.stepConcreteRecipeText]: "Traço",
  [ConcretingRequestMessages.stepPumpText]: "Bomba",
  [ConcretingRequestMessages.requestNewConcretingText]:
    "Solicitar nova programação",
  [ConcretingRequestMessages.clientWithPendencyText]:
    "Cliente possui pendência, entre em contato com o comercial.",
  [ConcretingRequestMessages.messagesDialogTitle]: "Mensagens",
  [ConcretingRequestMessages.messageUnderReview]:
    "Solicitação de programação sob análise. Em breve você receberá a confirmação ou não da programação.",
  [ConcretingRequestMessages.contractWithPendenciesMessage]:
  "Esse contrato possui pendências, favor entrar em contato com o departamento financeiro.",
  [ConcretingRequestMessages.inactiveContractMessage]:
  "Esse contrato está inativo, favor entrar em contato com o departamento financeiro."
};
